import injectScriptToHeaderTag from './injectScriptToHeaderTag';

let instance = null;

export default class CasaleScriptLoader {
    constructor() {
        if (!instance) {
            // console.log('Casale Script loader should only be run ONCE');
            this.loadCasaleScript();
            instance = this;
        }
        return instance;
    }

    // Inject Casale script to page head
    loadCasaleScript() {
        const casaleUrl = 'https://js-sec.indexww.com/ht/htw-zillow2.js';
        injectScriptToHeaderTag(casaleUrl);
    }
}
